import type { errorsAlertType } from './index';

const pt: errorsAlertType = {
  errors: {
    INVALID_COMBINATION_EMAIL_PASSWORD: {
      title: 'Erro de autenticação',
      message: 'E-mail e/ou senha inválidos',
    },
    BAD_REQUEST: {
      title: 'Erro na requisição',
      message: 'A requisição está irregular.',
    },
    ACCOUNT_ALREADY_EXISTS: {
      title: 'Usuário já existe',
      message: 'O usuário já existe no sistema.',
    },
    ACCOUNT_NOT_FOUND: {
      title: 'Usuário não encontrado',
      message: 'O usuário não foi encontrado no sistema.',
    },
    MEMBER_NOT_FOUND: {
      title: 'Membro não encontrado',
      message: 'O membro não foi encontrado no workspace.',
    },
    ERROR_CREATING_ACCOUNT: {
      title: 'Erro ao criar usuário',
      message: 'Erro ao tentar criar o usuário no sistema.',
    },
    EMAIL_ALREADY_IN_USE: {
      title: 'O email já está em uso',
      message: 'O email já está sendo utilizado, utilize outro email.',
    },
    PHONE_NUMBER_ALREADY_IN_USE: {
      title: 'O número de telefone já está em uso',
      message: 'O número de telefone já está sendo utilizado, utilize outro número.',
    },
    CNPJ_ALREADY_IN_USE: {
      title: 'O CNPJ já está em uso',
      message: 'O CNPJ já está sendo utilizado, utilize outro CNPJ.',
    },
    ERROR_ON_CREATING_CUSTOMER: {
      title: 'Erro ao registrar o cliente',
      message: 'Um erro no sistema foi encontrado ao tentar registrar o cliente.',
    },
    CUSTOMER_ALREADY_EXISTS: {
      title: 'Cliente já existe',
      message: 'O cliente já existe no sistema.',
    },
    CUSTOMER_EMAIL_ALREADY_IN_USE: {
      title: 'O email já está em uso',
      message: 'O email já está sendo utilizado, utilize outro email.',
    },
    CUSTOMER_CNPJ_ALREADY_IN_USE: {
      title: 'O CNPJ já está em uso',
      message: 'O CNPJ já está sendo utilizado, utilize outro CNPJ.',
    },
    CUSTOMER_NOT_FOUND: {
      title: 'Cliente não encontrado',
      message: 'O cliente não foi encontrado no sistema.',
    },
    CUSTOMER_NOT_UPDATED: {
      title: 'Cliente não foi atualizado',
      message: 'Erro ao tentar atualizar o cliente.',
    },
    CUSTOMER_NOT_DELETED: {
      title: 'Cliente não foi removido',
      message: 'Erro ao tentar remover o cliente.',
    },
    CUSTOMER_ALREADY_HAS_PASSWORD: {
      title: 'Uma senha já foi cadastrada',
      message: 'Você já possui uma senha, informe ela e depois a senha nova para alterá-la.',
    },
    WRONG_CUSTOMER_PASSWORD: {
      title: 'Senha errada',
      message: 'A senha informada está errada.',
    },
    MAIL_SEND_ERROR: {
      title: 'Erro ao enviar email',
      message: 'Não foi possível enviar o email.',
    },
    MAIL_PROVIDER_ERROR: {
      title: 'Erro no provedor de email',
      message: 'Um erro foi encontrado no provedor de email.',
    },
    REFRESH_TOKEN_NOT_FOUND: {
      title: 'Token não encontrado',
      message: 'O token de atualização no foi encontrado no sistema.',
    },
    REFRESH_TOKEN_EXPIRED: {
      title: 'Token expirou',
      message: 'O token de atualização expirou.',
    },
    REFRESH_TOKEN_DEVICE_MISMATCH: {
      title: 'Erro de token de atualização',
      message:
        'Não é possível utilizar o token de atualização que foi gerado por outro dispositivo.',
    },
    REFRESH_TOKEN_DELETE_ERROR: {
      title: 'Erro ao remover token',
      message: 'Foi encontrado um erro ao tentar remover o token de atualização.',
    },
    NO_AUTH_HEADER: {
      title: 'Token de acesso não encontrado',
      message: 'Informe o token de acesso.',
    },
    INVALID_TOKEN: {
      title: 'Token inválido',
      message: 'O token de acesso é inválido.',
    },
    CONTACT_ALREADY_EXISTS: {
      title: 'Contato já existe',
      message: 'O contato já existe no sistema.',
    },
    CONTACT_NOT_FOUND: {
      title: 'Contato não encontrado',
      message: 'O contato não foi encontrado no sistema.',
    },
    CONTACT_UPDATE_ERROR: {
      title: 'Contato não foi atualizado',
      message: 'Erro ao tentar atualizar o contato.',
    },
    CONTACT_DELETE_ERROR: {
      title: 'Contato não foi removido',
      message: 'Erro ao tentar remover o contato.',
    },
    FILE_SAVE_ERROR: {
      title: 'Erro ao salvar arquivo',
      message: 'Erro ao tentar salvar o arquivo no sistema.',
    },
    FOLDER_NOT_FOUND: {
      title: 'Pasta não encontrada',
      message: 'A pasta não foi encontrada no sistema.',
    },
    FOLDER_NOT_UPDATED: {
      title: 'Erro ao atualizar pasta',
      message: 'Erro ao tentar atualizar a pasta no sistema.',
    },
    FOLDER_NOT_DELETED: {
      title: 'Erro ao remover pasta',
      message: 'Erro ao tentar remover a pasta no sistema.',
    },
    FOLDER_RELATIONSHIP_NOT_FOUND: {
      title: 'Vínculo não encontrado',
      message: 'O cliente não possui acesso à pasta.',
    },
    ERROR_CREATING_FOLDER: {
      title: 'Erro ao criar pasta',
      message: 'Erro ao tentar criar a pasta no sistema.',
    },
    DOCUMENT_CREATE_ERROR: {
      title: 'Erro ao criar documento',
      message: 'Erro ao tentar criar documento no sistema.',
    },
    DOCUMENT_NOT_FOUND: {
      title: 'Documento não encontrado',
      message: 'O documento não foi encontrado no sistema.',
    },
    DOCUMENT_NOT_IN_WORKSPACE: {
      title: 'Documento não autorizado',
      message: 'O documento não pertence ao workspace.',
    },
    DOCUMENT_DELETE_ERROR: {
      title: 'Erro ao remover documento',
      message: 'Foi encontrado um erro ao tentar remover o documento.',
    },
    ERROR_CREATING_RELATIONSHIP: {
      title: 'Erro ao criar relacionamento',
      message: 'Não foi possível compartilhar os documentos selecionados.',
    },
    RELATIONSHIP_ALREADY_EXISTS: {
      title: 'Relacionamento já existe',
      message: 'O relacionamento já existe no sistema.',
    },
    CONFIRM_ACCOUNT: {
      title: 'Confirme sua conta',
      message: 'Você precisa confirmar sua conta para acessar o sistema.',
    },
    VERIFICATION_CODE_EXPIRED_OR_INVALID: {
      title: 'Código inválido',
      message: 'O código de verificação é inválido ou expirou.',
    },
    ATTRIBUTE_PRINCIPAL_ALREADY_EXISTS: {
      title: 'Atributo principal já existe',
      message: 'O atributo principal já existe no sistema.',
    },
    ATTRIBUTE_PRINCIPAL_NOT_FOUND: {
      title: 'Vínculo de usuário ao atributo não encontrado',
      message: 'O vínculo do usuário ao atributo não foi encontrado no sistema.',
    },
    ERROR_CREATING_ATTRIBUTE_PRINCIPAL: {
      title: 'Erro ao criar vínculo de usuário ao atributo',
      message: 'Erro ao tentar criar o vínculo do usuário ao atributo no sistema.',
    },
    ERROR_REMOVING_ATTRIBUTE_PRINCIPAL: {
      title: 'Erro ao remover vínculo de usuário ao atributo',
      message: 'Erro ao tentar remover o vínculo do usuário ao atributo no sistema.',
    },
    ERROR_UPDATING_ATTRIBUTE_PRINCIPAL: {
      title: 'Erro ao atualizar vínculo de usuário ao atributo',
      message: 'Erro ao tentar atualizar o vínculo do usuário ao atributo no sistema.',
    },
    ATTRIBUTE_RESOURCE_ALREADY_EXISTS: {
      title: 'Vínculo de recurso do atributo já existe',
      message: 'O vínculo recurso do atributo já existe no sistema.',
    },
    ATTRIBUTE_RESOURCE_NOT_FOUND: {
      title: 'Vínculo de recurso do atributo não encontrado',
      message: 'O vínculo recurso do atributo não foi encontrado no sistema.',
    },
    ERROR_CREATING_ATTRIBUTE_RESOURCE: {
      title: 'Erro ao criar vínculo de recurso do atributo',
      message: 'Erro ao tentar criar o vínculo recurso do atributo no sistema.',
    },
    ERROR_REMOVING_ATTRIBUTE_RESOURCE: {
      title: 'Erro ao remover vínculo de recurso do atributo',
      message: 'Erro ao tentar remover o vínculo recurso do atributo no sistema.',
    },
    ERROR_UPDATING_ATTRIBUTE_RESOURCE: {
      title: 'Erro ao atualizar vínculo de recurso do atributo',
      message: 'Erro ao tentar atualizar o vínculo recurso do atributo no sistema.',
    },
    ATTRIBUTE_ALREADY_EXISTS: {
      title: 'Atributo já existe',
      message: 'O atributo já existe no sistema.',
    },
    ATTRIBUTE_NOT_FOUND: {
      title: 'Atributo não encontrado',
      message: 'O atributo não foi encontrado no sistema.',
    },
    ERROR_CREATING_ATTRIBUTE: {
      title: 'Erro ao criar atributo',
      message: 'Erro ao tentar criar o atributo no sistema.',
    },
    ERROR_REMOVING_ATTRIBUTE: {
      title: 'Erro ao remover atributo',
      message: 'Erro ao tentar remover o atributo no sistema.',
    },
    ERROR_UPDATING_ATTRIBUTE: {
      title: 'Erro ao atualizar atributo',
      message: 'Erro ao tentar atualizar o atributo no sistema.',
    },
    USER_NOT_INVITED: {
      title: 'Erro ao aceitar o convite',
      message: 'Você não foi convidado para o workspace ou está logado com outro usuário.',
    },
    INVITE_EXPIRED: {
      title: 'Convite expirado',
      message: 'O convite expirou.',
    },
    INVITE_NOT_FOUND: {
      title: 'Convite não encontrado',
      message: 'O convite não foi encontrado no sistema.',
    },
    UPDATE_ACCOUNT_PROFILE: {
      title: 'Erro ao atualizar o perfil da conta',
      message: 'Não foi possível atualizar o perfil da conta, tente novamente mais tarde.',
    },
    CREATE_WORKSPACE: {
      title: 'Erro ao criar o workspace',
      message: 'Não foi possível criar o workspace, tente novamente mais tarde.',
    },
    UPDATE_WORKSPACE: {
      title: 'Erro ao atualizar o workspace',
      message: 'Não foi possível atualizar o workspace, tente novamente mais tarde.',
    },
    SEND_CODE_EMAIL: {
      title: 'Erro ao enviar o código',
      message:
        'Não foi possível enviar o código para seu email, por favor tente novamente mais tarde.',
    },
    CHANGE_EMAIL: {
      title: 'Erro ao alterar o email',
      message: 'Não foi possível alterar o email, por favor tente novamente mais tarde.',
    },
    INVALID_CODE: {
      title: 'Código Inválido',
      message: 'O código está inválido.',
    },
    INVALID_CURRENT_PASSWORD: {
      title: 'Senha',
      message: 'A senha atual está incorreta.',
    },
    CHANGE_PASSWORD: {
      title: 'Erro ao alterar a senha da conta',
      message: 'Não foi possível alterar a senha, por favor tente novamente mais tarde.',
    },
    USER_ALREADY_ACTIVE: {
      title: 'Usuário Ativo',
      message: 'O usuário já está ativo',
    },
    USER_NOT_ACTIVATED: {
      title: 'Usuário Inativo',
      message: 'Confirme sua conta',
    },
    NO_REDIRECT_EXTERNAL_URL: {
      title: 'URL Externa não permitida',
      message: 'A URL externa não é permitida, por favor entre em contato com o suporte.',
    },
    USER_NOT_ALLOWED: {
      title: 'Usuário não tem permissão',
      message: 'O usuário não tem permissão para essa ação.',
    },
    MIMES_NOT_ALLOWED: {
      title: 'Arquivo não permitido',
      message: 'O tipo de arquivo não é permitido.',
    },
    INTERNAL_SERVER_ERROR: {
      title: 'Erro interno',
      message: 'Um erro interno foi encontrado, por favor tente novamente mais tarde.',
    },
    NOT_FOUND: {
      title: 'Não encontrado',
      message: 'O recurso não foi encontrado',
    },
    ERROR_CREATING_WORKSPACE: {
      title: 'Workspace',
      message:
        'Erro ao criar o workspace. Certifique-se de que não exista um workspace vinculado ao seu email',
    },
  },
};

export default pt;
